(function () {
    "use strict";

    angular
        .module("app.productDetail")
        .controller("ProductDetailController", ProductDetailController);

    ProductDetailController.$inject = [
        "$scope",
        "ProductDetailService",
        "GeneralService",
        "$cookies",
        "$uibModal",
        "SharedData",
    ];

    function ProductDetailController(
        $scope,
        ProductDetailService,
        GeneralService,
        $cookies,
        $uibModal,
        SharedData
    ) {
        /* jshint validthis:true */
        var vm = this;
        var lastProductView = false;
        vm.productFeatures = [];
        vm.selectedVariant = {};
        vm.SharedData = SharedData;

        function activate() {}

        window.addEventListener(
            "hashchange",
            function () {
                $scope.$apply();
            },
            false
        );

        vm.getBankList = function () {
            GeneralService.GetBanks({
                PageSize: -1,
            }).then(function (data) {
                vm.bankList = data.data;
                vm.commericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == true &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
                vm.nonCommericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == false &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
            });
        };

        $scope.$watch(
            function () {
                return location.href;
            },
            function (value) {
                if (value) {
                    var hash = decodeURI(value.split("#")[1]);
                    if (hash != "undefined") {
                        vm.selectedVariant = vm.productFeatures.find(function (
                            item
                        ) {
                            if (!lastProductView) {
                                AddLastViewProductList(item.ProductCode);
                                lastProductView = true;
                            }
                            return item.Code == hash;
                        });
                        if (vm.galleryId != undefined) {
                            vm.getGalleryListLoad(vm.galleryId);
                        }
                    }
                }
            }
        );
        vm.getGalleryListLoad = function (GalleryId) {
            var owl = $(".gallery-mazaka-slider");
            owl.owlCarousel();
            owl.trigger("destroy.owl.carousel");
            vm.galleryId = GalleryId;
            vm.galleryMediaList = [];
            setTimeout(function () {
                var filter = {
                    GalleryId: GalleryId,
                    OrProductId: vm.selectedVariant.Id,
                    OrCategoryId: vm.selectedVariant.MainCategoryId,
                    IsImage: true,
                };
                GeneralService.getGalleryMediaList(filter).then(function (
                    data
                ) {
                    vm.galleryMediaList = data.data;
                    setTimeout(function () {
                        initSlider(".gallery-mazaka-slider");
                    }, 1000);
                });
            }, 1000);
        };

        vm.OpenPhotosModal = function (productId) {
            ProductDetailService.getProduct(productId).then(function (data) {
                vm.productImages = data.data.ProductMedia;
                setTimeout(function () {
                    $(
                        ".group-product-images .group-product-image"
                    ).magnificPopup({
                        type: "image",
                        gallery: {
                            enabled: true,
                        },
                    });
                    $(
                        $(".group-product-images .group-product-image")[0]
                    ).click();
                }, 100);
            });
        };

        function getCookieByName(name) {
            return $cookies.get(name);
        }

        function setCookie(name, value) {
            $cookies.put(name, value);
        }

        function AddLastViewProductList(value) {
            const unique = (value, index, self) => {
                return self.indexOf(value) === index;
            };
            var lastviewProduct = getCookieByName("LastViewProduct");

            var lastViewProductList = [];
            if (lastviewProduct)
                lastViewProductList = lastviewProduct.split(",");
            if (lastViewProductList) {
                if (!lastViewProductList.find((x) => x == value)) {
                    if (lastViewProductList.length != 5) {
                        lastViewProductList.unshift(value);
                    } else {
                        lastViewProductList.shift();
                        lastViewProductList.unshift(value);
                    }
                }
            }
            lastViewProductList = lastViewProductList.filter(unique);
            setCookie("LastViewProduct", lastViewProductList);
        }

        activate();
    }
})();
